export default "__VITE_ASSET__DkmhYWuL__"